import React from 'react';
import { MiniSlider } from './MiniSlider';
import type { PatientPreset } from '../types/simulation';
type PatientCaseStepProps = {
  patient: PatientPreset;
  adjusted: boolean;
  onAdjust: (patch: {
    weight?: number;
    amh?: number;
  }) => void;
  onResetValues: () => void;
  actions: React.ReactNode;
};
export function PatientCaseStep({
  patient,
  adjusted,
  onAdjust,
  onResetValues,
  actions
}: PatientCaseStepProps) {
  return <div className="flex min-h-[420px] flex-col" data-id="element-195" data-mp="15w405f5y7d5o">
      <p className="text-sm text-graphite" data-id="element-196" data-mp="19w4hb7kfm2gf">
        Patient {patient.id} · Female, {patient.age} years
      </p>
      <h2 className="mt-2 max-w-3xl font-serif text-4xl font-normal tracking-[-0.01em] text-ink md:text-5xl" data-id="element-197" data-mp="vx4u84ckhvmd">
        How would you start stimulation for this patient today?
      </h2>

      <dl className="mt-10 grid max-w-3xl grid-cols-2 border-y border-rule" data-id="element-198" data-mp="3gn3ya2qhrkjp">
        <div className="py-6 pr-4 sm:pr-6" data-id="element-199" data-mp="3gp6x9c9mgo0k">
          <dt className="text-xs text-graphite" data-id="element-200" data-mp="3lm725juqjkq3">Body weight</dt>
          <dd className="mt-1 font-serif text-[48px] font-light leading-none tracking-[-0.03em] text-ink tabular-nums sm:text-[72px] md:text-[104px]" data-id="element-201" data-mp="213vsp7fjbsnl">
            {patient.weight}
            <span className="ml-2 font-sans text-base tracking-normal text-graphite sm:ml-3 sm:text-2xl" data-id="element-202" data-mp="1x4d8yezg9nmc">kg</span>
          </dd>
          <div className="mt-4" data-id="element-203" data-mp="2638dznqrcro2">
            <MiniSlider id="patient-weight" label="Body weight" unit="kg" min={40} max={120} value={patient.weight} onChange={weight => onAdjust({
            weight
          })} data-id="element-204" data-mp="261xdbwsm0016" />
          </div>
        </div>
        <div className="border-l border-rule py-6 pl-4 sm:pl-6 md:pl-10" data-id="element-205" data-mp="2trhx2hwl71bi">
          <dt className="text-xs text-graphite" data-id="element-206" data-mp="2osy8sauitdfz">AMH</dt>
          <dd className="mt-1 font-serif text-[48px] font-light leading-none tracking-[-0.03em] text-ink tabular-nums sm:text-[72px] md:text-[104px]" data-id="element-207" data-mp="2ovjbf22n7xes">
            {patient.amh}
            <span className="ml-2 font-sans text-base tracking-normal text-graphite sm:ml-3 sm:text-2xl" data-id="element-208" data-mp="2yt783xjt7ezl">pmol/L</span>
          </dd>
          <div className="mt-4" data-id="element-209" data-mp="35szojf67vo11">
            <MiniSlider id="patient-amh" label="AMH" unit="pmol/L" min={1} max={60} value={patient.amh} onChange={amh => onAdjust({
            amh
          })} data-id="element-210" data-mp="3atdtgociuhuu" />
          </div>
        </div>
      </dl>

      <div className="mt-6 flex max-w-3xl flex-wrap items-baseline justify-between gap-4" data-id="element-211" data-mp="3pjcrmr42ttab">
        <p className="max-w-xl text-[15px] leading-relaxed text-graphite" data-id="element-212" data-mp="3tk52tpwie898">
          Use the case as given, or adjust weight and AMH to explore a different profile.
        </p>
        {adjusted && <button type="button" onClick={onResetValues} className="text-sm text-accent underline-offset-4 transition-colors duration-150 hover:text-ink hover:underline" data-id="element-213" data-mp="7cyj57okubjb">
            Reset to case values
          </button>}
      </div>

      <div className="mt-auto flex items-center justify-end gap-4 pt-10" data-id="element-214" data-mp="21kshnvyktdb4">{actions}</div>
    </div>;
}